// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"450":"bba86677","472":"fe37f10d","528":"d38e8dd0","941":"da624c28"}[chunkId] + ".css";
};